import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/layouts/Bullseye/bullseye';
import { FocusTrap } from '../../helpers';
import { AboutModalBoxContent } from './AboutModalBoxContent';
import { AboutModalBoxHeader } from './AboutModalBoxHeader';
import { AboutModalBoxHero } from './AboutModalBoxHero';
import { AboutModalBoxBrand } from './AboutModalBoxBrand';
import { AboutModalBoxCloseButton } from './AboutModalBoxCloseButton';
import { AboutModalBox } from './AboutModalBox';
import { Backdrop } from '../Backdrop/Backdrop';
export var AboutModalContainer = function AboutModalContainer(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isOpen = _a.isOpen,
      isOpen = _a$isOpen === void 0 ? false : _a$isOpen,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      _a$productName = _a.productName,
      productName = _a$productName === void 0 ? '' : _a$productName,
      trademark = _a.trademark,
      brandImageSrc = _a.brandImageSrc,
      brandImageAlt = _a.brandImageAlt,
      backgroundImageSrc = _a.backgroundImageSrc,
      closeButtonAriaLabel = _a.closeButtonAriaLabel,
      aboutModalBoxHeaderId = _a.aboutModalBoxHeaderId,
      aboutModalBoxContentId = _a.aboutModalBoxContentId,
      props = __rest(_a, ["children", "className", "isOpen", "onClose", "productName", "trademark", "brandImageSrc", "brandImageAlt", "backgroundImageSrc", "closeButtonAriaLabel", "aboutModalBoxHeaderId", "aboutModalBoxContentId"]);

  if (!isOpen) {
    return null;
  }

  return React.createElement(Backdrop, null, React.createElement(FocusTrap, {
    focusTrapOptions: {
      clickOutsideDeactivates: true
    },
    className: css(styles.bullseye)
  }, React.createElement(AboutModalBox, {
    className: className,
    "aria-labelledby": aboutModalBoxHeaderId,
    "aria-describedby": aboutModalBoxContentId
  }, React.createElement(AboutModalBoxBrand, {
    src: brandImageSrc,
    alt: brandImageAlt
  }), React.createElement(AboutModalBoxCloseButton, {
    "aria-label": closeButtonAriaLabel,
    onClose: onClose
  }), productName && React.createElement(AboutModalBoxHeader, {
    id: aboutModalBoxHeaderId,
    productName: productName
  }), React.createElement(AboutModalBoxContent, Object.assign({
    trademark: trademark,
    id: aboutModalBoxContentId,
    noAboutModalBoxContentContainer: false
  }, props), children), React.createElement(AboutModalBoxHero, {
    backgroundImageSrc: backgroundImageSrc
  }))));
};